export default "__VITE_ASSET__1moo0waS__"